import Component from '../classes/Component';
import gsap from 'gsap';
// Make sure ScrollTrigger is registered, e.g., in your main app.js
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);

export default class ImageRevealHorizontal extends Component {
  constructor({ element }) {
    super({ element });
    this.element = element;

    // --- NEW ---
    this.mm = gsap.matchMedia(); // 1. Create matchMedia instance
    this._setupAnimation();       // 2. Call setup method
  }

  _setupAnimation() {
    // --- NEW ---
    // 3. Add the desktop media query
    this.mm.add("(min-width: 1024px)", () => {

      // 4. Create the animation *inside* the media query
      this.animation = gsap.fromTo(this.element, {
        clipPath: 'inset(0% 100% 0% 0%)',
        xPercent: '30%',
      }, {
        clipPath: 'inset(0% 0% 0% 0%)',
        xPercent: '0%',
        duration: 1.5,
        ease: 'expo.inOut',
        scrollTrigger: {
          trigger: this.element,
          start: 'top 90%',
          toggleActions: 'play none none none',
          markers: false,
        }
      });

      // 5. Return a cleanup function
      return () => {
        this.animation?.kill();
      };

    });
    // --- END NEW ---
  }

  // _animateIn() is no longer needed as its logic
  // is now inside _setupAnimation()

  destroy() {
    // --- MODIFIED ---
    // 6. Revert the matchMedia instance on destroy
    // This cleans up all tweens/triggers created within it
    this.mm.revert();
  }
}